var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('img',{attrs:{"src":require("assets/btn-close.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }